import {
  DragItemSmall,
  DropItem,
} from './interactive-response-categorise-small.constants';

export function checkAnswer(dropItem: DropItem, dragItem: DragItemSmall) {
  if (dropItem.dragItems[dragItem.id]) {
    const isCorrect = dropItem.id === dragItem.value;
    dropItem.dragItems[dragItem.id].isCorrect = isCorrect;
    dragItem.isCorrect = isCorrect;
  }
  return {
    dropItem,
    dragItem,
  };
}

export function checkAnswers(
  dropItems: DropItem[],
  dragItems: DragItemSmall[]
) {
  dragItems.forEach(dragItem => {
    dropItems.forEach(dropItem => {
      if (dropItem.dragItems[dragItem.id]) {
        const isCorrect = dropItem.id === dragItem.value;
        dropItem.dragItems[dragItem.id].isCorrect = isCorrect;
        dragItem.isCorrect = isCorrect;
      }
    });
  });
  return { dropItems, dragItems };
}

export function getResults(dragItems: DragItemSmall[]): {
  result: string;
  isEverythingCorrect: boolean;
} {
  const totalCorrect = dragItems.filter(di => di.isCorrect).length;
  const isEverythingCorrect = dragItems.length === totalCorrect;

  return {
    result: isEverythingCorrect ? `Good job! 🎉` : `Don't give up!`,
    isEverythingCorrect,
  };
}

export function resetIncorrectItemsSmall(
  currentDragItems: DragItemSmall[],
  currentDropItems: DropItem[]
) {
  const updatedDragItems = [...currentDragItems];
  const updatedDropItems = [...currentDropItems];

  // Find incorrectly placed items in all drop items
  currentDropItems.forEach((dropItem, dropIndex) => {
    const updatedDragItems_obj = { ...dropItem.dragItems };

    // Check each drag item in this drop item
    Object.keys(dropItem.dragItems).forEach(dragItemId => {
      const dragItemInfo = dropItem.dragItems[dragItemId];

      // If the item is incorrect, reset it
      if (dragItemInfo.isCorrect === false) {
        // Find the drag item that was incorrectly placed
        const dragItemIndex = updatedDragItems.findIndex(
          drag => drag.id === dragItemId
        );

        if (dragItemIndex !== -1) {
          // Reset the drag item to not dropped
          updatedDragItems[dragItemIndex] = {
            ...updatedDragItems[dragItemIndex],
            isDropped: false,
            isCorrect: undefined,
          };
        }

        // Remove the drag item from this drop item
        delete updatedDragItems_obj[dragItemId];
      }
      // For correct items, keep them as they are (preserve isCorrect: true)
      // No need to modify anything - they stay highlighted and in place
    });

    updatedDropItems[dropIndex] = {
      ...updatedDropItems[dropIndex],
      dragItems: updatedDragItems_obj,
    };
  });

  return {
    dragItems: updatedDragItems,
    dropItems: updatedDropItems,
  };
}
